import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const LargeSearchIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 59 59" sx={{ width: '59px', height: '59px', ...sx }} {...props}>
      <path
        d="M51.625 51.625L40.9312 40.9312M27.0417 14.75C33.8302 14.75 39.3333 20.2532 39.3333 27.0417M46.7083 27.0417C46.7083 37.9033 37.9033 46.7083 27.0417 46.7083C16.1801 46.7083 7.375 37.9033 7.375 27.0417C7.375 16.1801 16.1801 7.375 27.0417 7.375C37.9033 7.375 46.7083 16.1801 46.7083 27.0417Z"
        stroke="black"
        strokeWidth="4.91667"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={'transparent'}
      />
    </SvgIcon>
  );
};

export default LargeSearchIcon;
